// extracted by mini-css-extract-plugin
export default {"form-container":"Signup_form-container__T-BES","title":"Signup_title__M+5Uv","form-group":"Signup_form-group__gz9Yv","button":"Signup_button__VwAr1"};